export const PUBLIC_BOARD_PREVIEW_MAX_WIDTH = '810px';
